<template>
  <transition>
    <div v-if="position > 500" class="scrollTop">
      <div class="button" @click="toTop" />
    </div>
  </transition>
</template>

<script>
/**
 * スクロールトップ
 */
export default {
  name: 'ScrollTop',
  data() {
    return {
      position: 0,
    }
  },
  created() {
    window.addEventListener('scroll', this.getPosition)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getPosition)
  },
  methods: {
    getPosition() {
      this.position = document.documentElement.scrollTop || document.body.scrollTop
    },
    toTop() {
      let scrolled = window.pageYOffset
      window.scrollTo(0, Math.floor(scrolled * 0.8))
      if (scrolled > 0) {
        window.setTimeout(this.toTop, 10)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.scrollTop {
  bottom: 40px;
  display: flex;
  justify-content: flex-end;

  @supports (position: sticky) {
    position: -webkit-sticky;
    position: sticky;
  }
}

.button {
  align-items: center;
  background: #fff;
  border: solid 1px #000;
  bottom: 88px;
  cursor: pointer;
  display: none;
  height: 40px;
  justify-content: center;
  position: fixed;
  transition: all 0.3s;
  width: 40px;

  @supports (position: sticky) {
    bottom: 0;
    position: absolute;
  }

  &:after {
    border-right: 1px solid #000;
    border-top: 1px solid #000;
    content: '';
    height: 12px;
    margin-top: 8px;
    transform: rotate(-45deg);
    width: 12px;
  }
  @media screen and (min-width: 768px) {
    display: flex;
    right: 24px;
  }
  @media screen and (min-width: 1280px) {
    @supports (position: sticky) {
      right: -72px;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
